import { ExternalLink, H6, Link } from '@atlassian/mpac-primitives';
import { appDetailsLink } from '@atlassian/mpac-utils';
import * as React from 'react';
import { ResourceListItem, ResourceSubTitle } from './styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const CloudMigrationResource = props => {
  const {
    cloudMigrationInfo,
    onCloudMigrationResourceLinksClick
  } = props;
  if (!cloudMigrationInfo || cloudMigrationInfo !== null && cloudMigrationInfo !== void 0 && cloudMigrationInfo.pending) {
    return null;
  }
  const {
    alternateCloudAppKey,
    migrationDocumentation,
    featureDifferenceDocumentation
  } = cloudMigrationInfo;
  if (!migrationDocumentation && !featureDifferenceDocumentation) {
    return null;
  }
  return /*#__PURE__*/_jsxs(ResourceListItem, {
    children: [/*#__PURE__*/_jsx(H6, {
      as: "h4",
      children: "Cloud migration"
    }), /*#__PURE__*/_jsxs(ResourceSubTitle, {
      children: [migrationDocumentation && /*#__PURE__*/_jsxs(_Fragment, {
        children: ["Get to know the steps provided by the partner on", ' ', /*#__PURE__*/_jsx(ExternalLink, {
          href: migrationDocumentation,
          size: "medium",
          onClick: () => {
            onCloudMigrationResourceLinksClick('how to migrate to cloud');
          },
          children: "how to migrate to cloud"
        }), ".", ' ']
      }), featureDifferenceDocumentation && /*#__PURE__*/_jsxs(_Fragment, {
        children: ["You can also check the", ' ', /*#__PURE__*/_jsx(ExternalLink, {
          href: featureDifferenceDocumentation,
          size: "medium",
          onClick: () => {
            onCloudMigrationResourceLinksClick('feature parity');
          },
          children: "feature parity"
        }), ' ', "for quick evaluation."]
      })]
    }), alternateCloudAppKey && /*#__PURE__*/_jsx(ResourceSubTitle, {
      children: /*#__PURE__*/_jsx(Link, {
        target: "_blank",
        "aria-label": "View the cloud variant of this app open in new window",
        href: appDetailsLink().expand({
          appKey: alternateCloudAppKey
        }),
        size: "medium",
        onClick: () => {
          onCloudMigrationResourceLinksClick('View the cloud variant of this app');
        },
        children: "View the cloud variant of this app"
      })
    })]
  });
};